import request from "@/utils/request";

// 分页查询
export function queryToDoList(params) {
  return request({
    url: "/act/needDealt/page",
    method: "post",
    params,
  });
}

// 处理
export function completeTask(data) {
  return request({
    url: `/act/needDealt/completeTask`,
    method: "post",
    data: data,
  });
}

// 获取待办任务详情
export function dealtTaskInfo(taskId) {
  return request({
    url: `/act/needDealt/getDealtTaskInfo/${taskId}`,
    method: "get",
  });
}
